import { useCallback } from 'react';
import { useAppSelector, useAppDispatch } from '../ReduxToolkit/Hooks';
import { logout as logoutAction } from '../ReduxToolkit/Auth/AuthSlice';

export function useAuth() {
  const dispatch = useAppDispatch();
  const { currentUser, isAuthenticated, loading, error } = useAppSelector((state) => state.auth);

  const logout = useCallback(() => {
    dispatch(logoutAction());
  }, [dispatch]);

  return {
    user: currentUser,
    isAuthenticated,
    isLoading: loading,
    error,
    logout
  };
}
